import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";
import type { Tone } from "./tone";
import "./chip.css";

type Props = { tone?: Tone; icon?: IconName; children: ReactNode };

// Un'etichetta breve («titolare», «sei tu», «protetto»): fondo tenue, senza bordo, come nella proposta B.
export function Chip({ tone = "neutral", icon, children }: Props) {
  return (
    <span className="g-chip" data-tone={tone}>
      {icon ? <Icon name={icon} /> : null}
      {children}
    </span>
  );
}
